import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";

import Toolbox from "dashboard/components/Toolbox";
import ToolboxItem from "dashboard/components/ToolboxItem";
import FilterStatusCheckboxList from "dashboard/components/FilterStatusCheckboxList";
import FilterCheckbox from "dashboard/components/FilterCheckbox";
import StoryList from "dashboard/components/StoryList";
import Select from "components/library/Select";
import { STATUS, SORT } from "config/constants";
import {
  setFilter,
  unsetAllFilters,
  setSort,
  setSortFromDropdown,
} from "dashboard/actions/filters";
import {
  getDashboardListAsync,
  getDashboardListNextPageAsync,
} from "dashboard/actions/list";

import styles from "./SingleColumnDashView.css";

const mapStateToProps = state => ({
  list: state.dashboard.list,
  filters: state.dashboard.filters,
  isLoadingInitialList: state.dashboard.ui.isLoadingInitialList,
});

const mapDispatchToProps = {
  setFilter,
  unsetAllFilters,
  setSort,
  setSortFromDropdown,
  getDashboardListAsync,
  getDashboardListNextPageAsync,
};

class SingleColumnDashView extends React.Component {
  componentDidMount() {
    this.props.unsetAllFilters();
    this.props.setFilter({ pub_status: this.props.pubStatus });
    this.props.setSort(this.props.defaultSort.value);
    this.props.getDashboardListAsync();
  }

  render() {
    let stories = [];

    if (this.props.list && OrderedMap.isOrderedMap(this.props.list.items)) {
      stories = this.props.list.items.toArray();
    }

    return (
      <div className={styles.root}>
        <Toolbox>
          <Select
            onChange={this.props.setSortFromDropdown}
            className={styles.sortDropdown}
            disabled={this.props.sortDisabled}
          >
            {this.props.optionsForOrdering.map(sort => {
              return (
                <option key={sort.value} value={sort.value}>
                  {sort.label}
                </option>
              );
            })}
            ;
          </Select>

          <ToolboxItem name="Filter" className={styles.filterDropDown}>
            <FilterStatusCheckboxList
              statuses={this.props.optionsForStatusFilter}
            />
            <hr />
            <FilterCheckbox label="Your stories" filter={{ author: "me" }} />
          </ToolboxItem>
        </Toolbox>

        <div className={styles.stories}>
          <StoryList
            stories={stories}
            next={this.props.getDashboardListNextPageAsync}
            isLoadingInitialList={this.props.isLoadingInitialList}
            showPublishedDatetime={
              this.props.filters.ordering === SORT.BY_PUBLISHED_DATE.value
            }
          />
        </div>
      </div>
    );
  }
}

SingleColumnDashView.propTypes = {
  pubStatus: PropTypes.oneOf(["drafts", "published"]).isRequired,
  defaultSort: PropTypes.oneOf(Object.values(SORT)).isRequired,
  optionsForStatusFilter: PropTypes.arrayOf(
    PropTypes.oneOf(Object.values(STATUS))
  ).isRequired,
  optionsForOrdering: PropTypes.arrayOf(PropTypes.oneOf(Object.values(SORT)))
    .isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleColumnDashView);
